import { clearSession } from '../../authorisation-utils/sso-v1-utils/clear-session';
import { longTermToken } from '../events-manager';

export const performRedirect = (urlOrPath: string, shouldClearSession = true) => {
  if (shouldClearSession) {
    clearSession();
    longTermToken.clearToken();
  }
  window.location.assign(urlOrPath);
};

export const composeUrlWithSearchParams = (url: string, searchParams: Record<string, string> = {}): string => {
  const urlSearchParams = new URLSearchParams({ ...searchParams });
  const urlSearchParamsString = urlSearchParams.toString();
  return url + (urlSearchParamsString ? '?' + decodeURIComponent(urlSearchParamsString) : '');
};
